class MissedCustomersListController {
  /**
   * @param moment
   * @param jobService
   * @param modalService
   * @param {FlashService} FlashService
   * @param analyticsService {AnalyticsService}
   */
  constructor(moment, jobService, modalService, FlashService, analyticsService) {
    // noinspection BadExpressionStatementJS
    'ngInject';

    this.moment = moment;
    this.modalService = modalService;
    this.flashService = FlashService;
    this.analyticsService = analyticsService;

    /**
     * @type {{value: MissedCustomer[], loading: boolean, error: boolean}}
     */
    this.result = {
      loading: true,
      value: undefined,
      error: false
    };
  }

  $onInit() {
    this.analyticsService.getMissedCustomerOrders()
      .then(value => this.result = {
        loading: false,
        value
      })
      .catch(_ => this.result = {
        loading: false,
        error: true
      });
  }

  get hasMissedCustomers() {
    return !this.result.loading && !!this.result.value && !!this.result.value.length;
  }

  get noMissedCustomers() {
    return !this.result.loading && !!this.result.value && !this.result.value.length;
  }
}

const MissedCustomersListComponent = {
  template: `
  <div class="row mt">
  <div class="col-md-12">
    <div class="content-panel">
      <div class="row">
        <div class="col-sm-12 col-md-12">
          <h4>
            <i class="fa fa-users"></i>
            Customer orders to schedule this month</h4>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-9 col-md-9">
        </div>
      </div>

      <hr>
      <table class="table table-advance table-hover">
        <thead>
          <tr>
            <th>
              <i class="fa fa-user"></i>
              Customer Name</th>
            <th class="hidden-phone">
              <i class="fa fa-home"></i>
              Postcode</th>
            <th class="hidden-phone">
              <i class="fa fa-user"></i>
              Last Operative</th>
            <th></th>
          </tr>
          <tr ng-if="$ctrl.noMissedCustomers">
            <td colspan="4">
                <h4 class="text-success">All customers scheduled</h4>
            </td>
          </tr>
        </thead>
        <tbody>

          <tr ng-if="$ctrl.hasMissedCustomers" ng-repeat="customer in $ctrl.result.value">
            <td>
            <a ng-href="customers/{{customer.customerId}}/orders?orderId={{customer.orderId}}">
                {{ customer.customerName }}
            </a>
            </td>
            <td>{{ customer.postcode }}</td>
            <td>{{ customer.lastScheduleUser }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- /content-panel -->
  </div>
  <!-- /col-md-12 -->
</div>
  `,
  restrict: 'E',
  link: (scope, element, attrs) => {
  },
  scope: {},
  controller: MissedCustomersListController
};

angular.module('gfcmsApp').component('gfMissedCustomersList', MissedCustomersListComponent);
